export enum LeaveReportType {
    ListadoBaja,
    Employee,
    Selection,
}